import logo from '../images/yash.JPG';
export default function Hero(){
    return (
        <div>
            <div class="jumbotron jumbotron-fluid">
                <div class="container">
                  <img src={logo} className="img-circ" alt="" width="125px" height="125px"></img>
                  <h2 class="display-4 text-center">Yash Thaker</h2>
                  <p class="lead text-center">Coding aficionado & AI advocate. Passionate about merging technology & human potential for a brighter future.</p>
                  <hr class="my-4" />
                </div>
        </div>
        </div>
    )
}